import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import TabHeader from "../../common/TabHeader";
import Loading from "../../common/Loading";
import NoContent from "../../common/NoContent";
import { useAppContext } from "../../../providers/ProviderAppContainer";
import { getReadableDate, getWriteableDate } from "../../../utils";
import { TEXT_NORMAL, TEXT_SMALL } from "../../../style";

export default function Activities() {
    const { userId } = useOutletContext();
    const { requestAPI } = useAppContext();

    const [date, setDate] = useState(() => new Date());
    const [activities, setActivities] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        const day = getWriteableDate({ date, removeTime: true });
        if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return;

        requestAPI({
            requestPath: `users/${userId}/activities`,
            requestMethod: "GET",
            requestGetQuery: { date: day },
            setLoading,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (Array.isArray(data) && responseCode === 200) {
                    setActivities(data);
                    setError();
                } else {
                    setActivities();
                    setError(data?.error || "Couldn't load activities");
                }
            },
        });
    }, [date, requestAPI, userId]);

    return (
        <div className="flex flex-column h-full min-h-0">
            <TabHeader
                className="px-3 pt-3"
                title="Activities"
                highlights={[`Total - ${activities?.length ?? 0}`]}
                actionItems={[
                    <Calendar
                        key="activity-date"
                        value={date}
                        onChange={(event) => event.value && setDate(event.value)}
                        readOnlyInput
                        dateFormat="dd/mm/yy"
                        showIcon
                    />,
                ]}
            />
            <Divider />
            <div className="flex-1 min-h-0 px-3 pb-2 overflow-y-scroll gap-2 flex flex-column">
                {loading ? (
                    <Loading message="Loading Activities" />
                ) : error ? (
                    <NoContent error={error} />
                ) : activities?.length ? (
                    activities.map((entry) => (
                        <div key={entry.id} className="border-1 border-gray-300 border-round py-2 px-3 flex flex-column gap-1">
                            <span className={`${TEXT_NORMAL} font-semibold`}>{entry.activity}</span>
                            <span className={`${TEXT_SMALL} text-color-secondary`}>
                                <i className="pi pi-clock mr-1" />
                                {getReadableDate({ date: entry.created_on })}
                            </span>
                        </div>
                    ))
                ) : (
                    <NoContent error="No activities for this day" />
                )}
            </div>
        </div>
    );
}
